// ─── Public-site boot helpers ────────────────────────────────────────────────
// Visitors who are NOT logged in and open the website pages get a light bundle
// (landing page only). Everyone else boots the full ERP exactly as before.
export const PUBLIC_LANDING_PATHS = ['/', '/welcome', '/new-tenant', '/pricing'];

export function normPath(p) {
  return (String(p || '/').replace(/\/+$/, '') || '/').toLowerCase();
}

// Same rule AppContext uses for currentUser: a saved session object in localStorage.
export function hasSavedSession() {
  try { return !!JSON.parse(localStorage.getItem('barkahflow_user') || 'null'); }
  catch { return false; }
}

export function isPublicLandingPath(p) {
  return PUBLIC_LANDING_PATHS.includes(normPath(p));
}
